import { HttpResponse, http, type HttpHandler } from 'msw';
import { BFF_ENDPOINTS } from '../../api/endpoints/BffEndpoints';
import { createMockCampaignsListResponse } from '../factories/campaigns';
import { toMSWPattern } from '../utils/generic';
import type { HTTP_METHODS } from './constants/generic';
import { HTTP_METHODS_VALUES } from './constants/generic';

interface HandlerMapping {
  pattern: string;
  key: string;
  method?: HTTP_METHODS;
}

interface HandlerWithMapping {
  handler: HttpHandler;
  mapping: HandlerMapping;
}

export const ENDPOINTS_KEYS = {
  CAMPAIGN_LIST: 'CAMPAIGN_LIST',
};

export function createCampaignHandlers(baseUrl: string): HandlerWithMapping[] {
  return [
    {
      handler: http.get(`${baseUrl}/${toMSWPattern(BFF_ENDPOINTS.CAMPAIGN_LIST)}`, () => {
        return HttpResponse.json(createMockCampaignsListResponse());
      }),
      mapping: {
        pattern: 'campaign_list',
        key: ENDPOINTS_KEYS.CAMPAIGN_LIST,
        method: HTTP_METHODS_VALUES.GET as HTTP_METHODS,
      },
    },
  ];
}
